/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Profile_LabelInputs */



/**
* | output |
* | --- |
* | "Export Profile" |
*
* @param {Image_Export_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_profile_label = /** @type {((inputs?: Image_Export_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportprofil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profilo di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профиль экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil de exportacion")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書き出しプロファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रोफ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Perfil de exportacao")
	return /** @type {LocalizedString} */ ("Export Profile")
});